import React from 'react';

const Hello = props => (
  <h3>Hello {props.name}!</h3>
)

export default Hello
